import axios from 'axios';
import React from 'react';
import { getFormData } from '../../common';

class UserSignup extends React.Component {
  componentDidMount() {
    const getValue = (_qs, _key) => {
      const keyVals = _qs.split("&");
      for (let idx in keyVals) {
        const keyVal = keyVals[idx];
        const key = keyVal.split("=")[0];
        const val = keyVal.split("=")[1];
        if (key === _key) return val;
      }
      return "";
    }

    const value = getValue(window.location.search.substring(1), "code");
    const username = window.atob(value).split("|")[1];
    if (!username)
      return;
    
    const userDom = document.getElementById("username");
    userDom.value = username;
  }

  onSubmit(evt) {
    evt.preventDefault();
    const url = evt.target.action;
    const formData = getFormData(evt.target);

    axios.post(url, formData).then((res) => {
      if (res.status === 200)
        window.location.href = "/everest-admin";
    });
  }

  render() {
    const formStyle = { width: 250 };

    return (
      <div>
        <br />
        <form action={"/oauth2/signup/everest/password"} onSubmit={this.onSubmit.bind(this)}>
          <div className={"form-group"}>
            <input style={formStyle} type={"text"} name={"username"} placeholder={"email"} id={"username"}></input>
          </div>
          <div className={"form-group"}>
            <input style={formStyle} type={"text"} name={"nickname"} placeholder={"닉네임"}></input>
          </div>
          <div className={"form-group"}>
            <input style={formStyle} type={"password"} name={"password"} placeholder={"비밀번호"}></input>
          </div>
          <div className={"form-group"}>
            <input style={formStyle} type={"password"} name={"password2"} placeholder={"비밀번호 확인"}></input>
          </div>
          <div className={"form-group"}>
            <button style={formStyle} type={"submit"} className={"btn btn-primary"}>회원가입</button>
          </div>
        </form>
      </div>
    );
  }
}

export { UserSignup };
